"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
const firestore_2 = require("@react-query-firebase/firestore");
const keyFactory_1 = require("../keyFactory");
/**
 *
 * @returns Los dependants
 */
function usePillboxRecipes(firestore, uid, options, queryOptions) {
    const pillboxRef = (0, firestore_1.collection)(firestore, `user/${uid}`, "pillbox");
    const queryPillboxRef = (0, firestore_1.query)(pillboxRef, (0, firestore_1.where)("active", "==", true));
    return (0, firestore_2.useFirestoreQuery)(keyFactory_1.FirestoreKeys.Pillbox({
        name: "PillboxRecipes",
        path: `user/${uid}/pillbox`
    }, [uid]), queryPillboxRef, options, {
        ...queryOptions,
        select: (pills) => {
            if (pills.empty) {
                return null;
            }
            else {
                const documents = [];
                pills.forEach(doc => {
                    documents.push({
                        ...doc.data(),
                        id: doc.id
                    });
                });
                return queryOptions?.select ? queryOptions.select(documents) : documents;
            }
        }
    });
}
exports.default = usePillboxRecipes;
